import React from 'react';
import * as Sentry from '@sentry/react';
import ReactGA from 'react-ga4';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID || '');
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/dashboardapi\.telosair\.com\/backend/,
    /^https:\/\/devdashboardapi\.telosair\.com\/backend/
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
